import TempoIconLight from 'assets/images/Repertoire/TempoIconLight.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  ListItemIcon,
  ListItemText,
  Slider,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Reset from 'assets/images/Repertoire/Reset.svg';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import LeftArrowIcon from 'assets/images/LeftArrowIcon.png';
import InfoIcon from 'assets/images/InfoIcon.png';
import Chevron1 from 'assets/images/Chevron1.png';
import ChevronSingle from 'assets/images/ChevronSingle.png';
import ChevronFilled from 'assets/images/ChevronFilled.png';
import ChevronLastFilled from 'assets/images/ChevronLastFilled.png';
import MinusIcon from 'assets/images/MinusIcon.png';
import PlusIcon from 'assets/images/PlusIcon.png';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import * as appActions from 'Actions/app';
import * as lessonActions from 'Actions/lesson';
import TempoPlus from 'assets/images/Repertoire/TempoPlus.png';
import TempoMinus from 'assets/images/Repertoire/TempoMinus.png';

import { ERROR_RECOGNITION_MODE, MainAppReducer } from 'Types';
// import { Levels } from '../../Constants/LevelData'
import { useNavigate } from 'react-router-dom';
import {
  useState,
  useEffect,
  useRef,
  useCallback,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';
import { BPM, ERROR_REC_CLASS, MIN_NUM_PHRASES, isCapacitorNative } from 'Utils/Constants';
import './Lesson.css';
import RepertoireUnlocked, { DEBUG_REPERTOIRE_UNLOCKED } from './RepertoireUnlocked';
import TierWrapUp from './TierWrapUp';
import UnitComplete from './UnitComplete';
import FooterContainer from './Footer';
// PauseContainer removed - now we skip the confirmation and go directly to wrap up or roadmap
import { range } from 'lodash';
import {
  colors,
  inProgressContainerStyles,
  completeContainerStyles,
} from 'Components/RoadmapComponents/Path';
import { v4 as uuid } from 'uuid';
import { getColorByCbType, MUSEFLOW_ORANGE } from 'Components/Colors';
import { LessonReducer } from 'Reducers/lessonReducer';
import { RepertoireReducer, RepertoireData } from 'Types/RepertoireTypes';
import logger from 'Utils/Logger';
import { sortBy } from 'lodash';
import Modal from 'Components/TierWrapUp/Modal';
import { useMediaQueries } from 'Hooks/useMediaQueries';
import { useHoldToRepeat } from 'Hooks/useHoldToRepeat';
import Navigation from 'Components/TierWrapUp/Navigation';
import BackToRoadmapButton from 'Components/TierWrapUp/BackToRoadmap';
import { useComponentWillUnmount } from 'Utils';
import { CustomSwitch } from 'Components/StyledComponents';
import AppTour, {
  AppTourStep,
  filterByUnseenFeatures,
  TooltipRelativePosition,
} from 'Components/AppTour';
import { ApptourFeature, ApptourFeatureItem } from 'Utils/AppTourFeatures';
import { AppDispatch } from 'Reducers';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Modal as MuiModal } from '@mui/material';
import { NotifyPhaserEvents, NotifyReactEvents } from 'Phaser/EventBus2';
import MainAppPhaser from 'Containers/MainApp/MainAppPhaser';
import { eventQueue } from 'Models/EventQueue';
import TempoControls from 'Components/Tempo';
import { TempoProvider, useTempoContext } from 'Contexts/TempoContext';
import { useMidiContext } from 'Contexts/MidiContext';
import type { AppTourProps } from 'Components/AppTour';
import { AppTourStepHelper } from 'Phaser/EventBus2/ToReact';
import type { ParallelModeConversion } from 'Utils/MusicXmlModeConversion';

const activationAccuracyValue = 95;

/** Wraps AppTour so onClose can call setTempo from TempoContext (only available inside TempoProvider). */
const LessonAppTour = (props: AppTourProps) => {
  const { changeTempo } = useTempoContext();
  const { onClose, ...rest } = props;
  console.debug('LessonAppTour', rest.steps);
  return (
    <AppTour
      {...rest}
      onClose={() => {
        changeTempo({ value: 72, goal: false });
        NotifyPhaserEvents.EndTour();
        NotifyReactEvents.AppTourHelper({
          step: AppTourStepHelper.EndTour,
        });
        onClose?.();
      }}
    />
  );
};

/** Loads stored BPM from user level progress and debounce-saves tempo changes back.
 *  Uses refs for currentUserLevelData to avoid a save→update→save infinite loop. */
const LessonTempoSyncer = () => {
  /*const { tempo, changeTempo, goalTempo, inAdaptiveSegment } = useTempoContext();
  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const { currentUserLevelData } = useSelector((state: LessonReducer) => state.lessonReducer);
  const dispatch = useDispatch<AppDispatch>();

  const currentLevelNumber = data.levelData[data.levelSelect]?.level_number;
  const currentTier = currentUserLevelData?.current_tier ?? 1;
  const storedTempo = data.tempoValues[currentLevelNumber]?.[currentTier];

  const hasLoadedBpm = useRef<number | undefined>(undefined);
  const lastSavedBpm = useRef<Record<number, number>>({});
  const lastSavedGoalTempo = useRef<number>(150);
  const ulpRef = useRef(currentUserLevelData);
  const tempoValuesRef = useRef(data.tempoValues);
  tempoValuesRef.current = data.tempoValues;
  ulpRef.current = currentUserLevelData;

  // Load BPM from ULP when data arrives and when stored value is available (e.g. after rehydration).
  // Re-run when storedTempo changes so we apply rehydrated tempo instead of default after page refresh.
  useEffect(() => {
    const matchesCurrentLevel = currentUserLevelData?.level?.level_number === currentLevelNumber;
    const fromStore = tempoValuesRef.current[currentLevelNumber]?.[currentTier];
    const valueToApply = fromStore ?? 72;
    const isFirstLoadForTier = hasLoadedBpm.current !== currentTier;
    const storedValueJustArrived =
      fromStore !== undefined && fromStore !== lastSavedBpm.current[currentTier];

    console.debug('[tempo sync] loading tempo', {
      currentLevelNumber,
      currentTier,
      hasLoadedBpm: hasLoadedBpm.current,
      fromStore,
      lastSavedBpm: JSON.stringify(lastSavedBpm.current),
    });
    if (
      (isFirstLoadForTier || storedValueJustArrived) &&
      currentUserLevelData &&
      matchesCurrentLevel &&
      !inAdaptiveSegment
    ) {
      hasLoadedBpm.current = currentTier;
      lastSavedBpm.current[currentTier] = valueToApply;
      console.debug('[tempo sync] loading tempo', {
        lastSavedBpm: JSON.stringify(lastSavedBpm.current),
      });
      changeTempo({
        value: valueToApply,
        goal: false,
      });
    }
  }, [
    currentUserLevelData,
    currentLevelNumber,
    changeTempo,
    currentTier,
    storedTempo,
    inAdaptiveSegment,
  ]);

  // Debounced save — only tempo in deps, uses ref for ULP to avoid loop.
  // Gate on hasLoadedBpm so we never save a stale tempo from a previous level.
  // Do not save default (72) when the store already has a different value for this tier (avoids
  // overwriting persisted tempo on load when context hasn't updated after load effect yet).
  useEffect(() => {
    if (
      hasLoadedBpm.current !== currentTier ||
      !ulpRef.current ||
      tempo === lastSavedBpm.current[currentTier] ||
      inAdaptiveSegment
    ) {
      return;
    }
    const storedForTier = tempoValuesRef.current[currentLevelNumber]?.[currentTier];
    if (tempo === 72 && storedForTier !== undefined && storedForTier !== 72) {
      return; // avoid overwriting stored value with default (e.g. context not yet updated after load)
    }
    console.debug('[tempo sync] saving tempo', {
      tempo,
      currentLevelNumber,
      currentTier,
      hasLoadedBpm: hasLoadedBpm.current,
      ulpRef: ulpRef.current,
      lastSavedBpm: JSON.stringify(lastSavedBpm.current),
    });
    const debounceTimer = setTimeout(() => {
      lastSavedBpm.current[currentTier] = tempo;
      dispatch(appActions.setTempo({ tempo, level: currentLevelNumber, tier: currentTier }));
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [tempo, dispatch, inAdaptiveSegment, currentLevelNumber, currentTier]);

  // Debounced save of goal tempo
  useEffect(() => {
    if (goalTempo === lastSavedGoalTempo.current) return;
    const debounceTimer = setTimeout(() => {
      dispatch(appActions.setCustomGoalTempo(goalTempo));
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [goalTempo, dispatch]);*/

  return null;
};

const minTempoForChevronFlash = 72;

interface LessonPageProps {
  [key: string]: unknown;
}

const LessonPage = (props: LessonPageProps) => {
  // const { midiProps } = props
  // const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();
  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  // const levelData = data.levelData[data.levelSelect];
  const {
    tierSummary,
    lessonProcessPending,
    currentLevelCompletedAt,
    currentUserLevelData,
    phrasesTilNextTier,
    currentLevelTiers,
    lessonPlaying,
    tierSummaryRequestError,
    showWrapUp,
    wrapUpIndex,
    completedPhrasesCount,
  } = useSelector((state: LessonReducer) => state.lessonReducer);
  const repertoireReducerData = useSelector((state: RepertoireReducer) => state.repertoireReducer);
  const { tiersByLevels, userData, tempo } = data;
  console.debug('tempo', tempo);
  const levelSelect = data.levelSelect;

  const unseenApptourFeatures = data.unseenApptourFeatures ?? [];
  const { showMidiModal } = useMidiContext();
  const tourTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [showTierComplete, setShowTierComplete] = useState(false);
  const [allowChevrons, setAllowChevrons] = useState(false);

  const [accuracyPercent, setAccuracyPercent] = useState<number | null>(0);
  const [showAccuracy, setShowAccuracy] = useState(false);

  const [currentTier, setCurrentTier] = useState(currentUserLevelData?.current_tier || 1);

  // Cursor visibility for sight reading is persisted in the main reducer so it
  // survives reloads (defaults to on). See setSightReadingCursorVisible.
  const cursorIsVisible = data.sightReadingCursorVisible ?? true;
  const setCursorIsVisible = (visible: boolean) =>
    dispatch(appActions.setSightReadingCursorVisible(visible));
  const [_newRepsUnlocked, setNewRepsUnlocked] = useState<RepertoireData[]>([]);
  const [_initialLevelCompletedAt] = useState(currentUserLevelData?.level_completed_at);
  const [playButtonOverlap, setPlayButtonOverlap] = useState(0);
  const [showSettings, setShowSettings] = useState(false);
  // Sight-reading transposition is a per-user preference persisted in the
  // backend (userData.sight_reading_transposition) so it survives reloads and
  // syncs across devices. Reading it straight from the main reducer keeps this
  // and the value handed to Phaser in lockstep. Changing it dispatches
  // updateUserData, which merges into the reducer AND triggers a
  // PATCH /user-data (see onUpdateUserData saga) to persist it to the database.
  const sightReadingTransposeSemitones = data.userData?.sight_reading_transposition ?? 0;
  const setSightReadingTransposeSemitones = (nextSemitones: number) =>
    dispatch(appActions.updateUserData({ sight_reading_transposition: nextSemitones }));
  const [sightReadingModeConversion, setSightReadingModeConversion] =
    useState<ParallelModeConversion>('off');
  const [sightReadingCurrentKeyLabel, setSightReadingCurrentKeyLabel] = useState<string | null>(
    null,
  );

  const repertoireData = repertoireReducerData?.repertoireData;
  const levelComplete =
    currentUserLevelData?.current_tier && currentUserLevelData?.current_tier >= currentLevelTiers;
  // Guard against currentLevelCompletedAt not being a proper Date object (can happen after Redux hydration)
  const getCurrentLevelCompletedAtTime = () => {
    if (!currentLevelCompletedAt) return null;
    if (currentLevelCompletedAt instanceof Date) return currentLevelCompletedAt.getTime();
    // If it's a string (from serialization), convert to Date first
    const asDate = new Date(currentLevelCompletedAt);
    return isNaN(asDate.getTime()) ? null : asDate.getTime();
  };
  const levelCompleteFirstTime =
    !currentUserLevelData?.level_completed_at ||
    (currentUserLevelData?.level_completed_at &&
      new Date(currentUserLevelData?.level_completed_at).getTime() ==
        getCurrentLevelCompletedAtTime());
  // Old logic:
  // const unitComplete =  currentUserLevelData?.level.level_number === sortBy(data.levelData, levelDatum => levelDatum.level_number).last().level_number && (currentUserLevelData?.current_tier === tiersByLevels[tiersByLevels.length - 1].tiers.length)
  // New, defensive:
  const unitComplete =
    !!currentUserLevelData?.level?.level_number &&
    currentUserLevelData.level.level_number ===
      sortBy(data.levelData ?? [], (l) => l.level_number).at(-1)?.level_number &&
    currentUserLevelData?.current_tier === tiersByLevels?.at(-1)?.tiers?.length;

  const [_hasStarted, _setHasStarted] = useState(false);
  const [carousel, setCarousel] = useState<ReactNode[]>([]);
  const { maxHeight, maxWidth } = useMediaQueries();

  const mediaQueries = { maxHeight, maxWidth };

  const [freePlay, setFreePlay] = useState(false);
  const [tourActive, setTourActive] = useState(false);
  const [skipIntro, setSkipIntro] = useState(false);
  // Non-empty means the selective new-feature tour is active; the array is the
  // feature list captured at activation. Latched here so the saga's refetch
  // can't clear unseenApptourFeatures mid-tour and flip the steps prop into
  // the full tour. Empty means full-tour mode (or no tour).
  const [activeFeatureList, setActiveFeatureList] = useState<ApptourFeatureItem[]>([]);
  const [_tourStepIndex, setTourStepIndex] = useState(0);
  //const [tempo, setTempo] = useState(BPM);
  const [filledInChevrons, setFilledInChevrons] = useState<number>(0);
  const [debugShowTierSummary, setDebugShowTierSummary] = useState(false); // local env toggle for Tier Summary modal
  const [debugShowRepertoireUnlocked, setDebugShowRepertoireUnlocked] = useState(false); // env toggle for Repertoire Unlocked modal
  const [showTutorialVideo, setShowTutorialVideo] = useState(false); // NEW: video modal toggle
  const [isSmallScreen, setIsSmallScreen] = useState(
    window.innerWidth <= 960 || window.innerHeight <= 500,
  );

  useEffect(() => {
    setFilledInChevrons(4 - phrasesTilNextTier);
  }, [phrasesTilNextTier]);

  const colors = {
    correct: getColorByCbType(ERROR_REC_CLASS.CORRECT, userData?.colorblind_type ?? null),
    semiError: getColorByCbType(ERROR_REC_CLASS.SEMI_ERROR, userData?.colorblind_type ?? null),
    error: getColorByCbType(ERROR_REC_CLASS.ERROR, userData?.colorblind_type ?? null),
  };

  const LessonTutorialSteps: (AppTourStep | null)[] = [
    {
      targetId: 'playButton',
      title: 'Play Button',
      content: isCapacitorNative()
        ? 'Tap the play button to start the level.'
        : 'Tap the play button or hit the spacebar to start the level.',
      position: TooltipRelativePosition.LEFT,
    },
    {
      targetId: 'game-container',
      title: 'Playing Notes',
      content: 'Play the notes on screen in sync with the metronome.',
      position: TooltipRelativePosition.BOTTOM,
      positionOffset: [0, -200],
      preStepFunction: () =>
        NotifyPhaserEvents.SetAppTourStep({
          step: 'playback',
          cbType: data.userData?.colorblind_type ?? null,
        }),
      //postStepFunction: () => NotifyPhaser(EndTourEvent()),
      onClose: () => NotifyPhaserEvents.EndTour(),
    },
    {
      targetId: 'game-container',
      positionTarget: 'note-pos-dummy',
      title: 'Perfect Notes',
      content: (
        <>
          Notes will turn <span style={{ color: colors.correct }}>green</span> when you play them
          perfectly.
        </>
      ),
      position: TooltipRelativePosition.RIGHT,
      positionOffset: [0, 20],
      preStepFunction: () =>
        NotifyPhaserEvents.SetAppTourStep({
          step: 'perfect-notes',
          cbType: data.userData?.colorblind_type ?? null,
        }),
      //postStepFunction: () => NotifyPhaser(ResetNoteColor()),
      onClose: () => NotifyPhaserEvents.EndTour(),
    },
    {
      targetId: 'game-container',
      positionTarget: 'note-pos-dummy',
      title: 'Off-Time Notes',
      content: (
        <>
          They will turn <span style={{ color: colors.semiError }}>yellow</span> if your timing is a
          bit off.
        </>
      ),
      position: TooltipRelativePosition.RIGHT,
      positionOffset: [0, 20],
      preStepFunction: () =>
        NotifyPhaserEvents.SetAppTourStep({
          step: 'off-time-notes',
          cbType: data.userData?.colorblind_type ?? null,
        }),
      //postStepFunction: () => NotifyPhaser(ResetNoteColor()),
      onClose: () => NotifyPhaserEvents.EndTour(),
    },
    {
      targetId: 'game-container',
      positionTarget: 'note-pos-dummy',
      title: 'Missed Notes',
      content: (
        <>
          And if you miss a note entirely or play an incorrect note, it will turn{' '}
          <span style={{ color: colors.error }}>red</span>.
        </>
      ),
      position: TooltipRelativePosition.LEFT,
      positionOffset: [0, 20],
      preStepFunction: () =>
        NotifyPhaserEvents.SetAppTourStep({
          step: 'error-notes',
          cbType: data.userData?.colorblind_type ?? null,
        }),
      // Only end the tour when advancing forward out of the coloring section.
      // Going backward (red -> yellow) must keep the tour alive so the
      // destination step's coloring/cursor isn't torn down right after it's
      // applied. Close (direction undefined) still ends via this + onClose.
      postStepFunction: (direction) => {
        if (direction !== 'backward') NotifyPhaserEvents.EndTour();
      },
      onClose: () => NotifyPhaserEvents.EndTour(),
    },
    {
      targetId: 'accuracy',
      title: 'Running Accuracy',
      content: 'Stay above 95% accuracy to collect chevrons, and keep them.',
      position: TooltipRelativePosition.LEFT,
      preStepFunction: () => {
        dispatch(lessonActions.updatePhrasesTilNextTier(3));
        setAccuracyPercent(95);
        setShowAccuracy(true);
      },
      postStepFunction: () => {
        console.debug('[Tour]postStepFunction');
      },
      onClose: () => {
        dispatch(lessonActions.updatePhrasesTilNextTier(4));
        setAccuracyPercent(null);
      },
    },
    {
      targetId: 'accuracy',
      title: 'Running Accuracy',
      content: 'Go under 75% accuracy, and you will lose chevrons.',
      position: TooltipRelativePosition.LEFT,
      preStepFunction: () => {
        console.debug('[Tour]prestep');
        dispatch(lessonActions.updatePhrasesTilNextTier(4));
        setAccuracyPercent(75);
        setShowAccuracy(true);
      },
      postStepFunction: () => {
        dispatch(lessonActions.updatePhrasesTilNextTier(4));
        setAccuracyPercent(null);
      },
    },
    {
      targetId: `tempo`,
      title: 'Tempo',
      content: 'Stay at (or above) goal tempo to enable chevrons.',
      position: TooltipRelativePosition.LEFT,
      preStepFunction: () => {
        dispatch(appActions.setTempo({ tempo: 72, level: currentLevelNumber, tier: currentTier }));
      },
    },
    {
      targetId: 'accuracy',
      title: 'Winning',
      content: 'Collect 4 chevrons to pass a level.',
      position: TooltipRelativePosition.LEFT,
      preStepFunction: () => {
        setFilledInChevrons(4);
        setAccuracyPercent(95);
        setShowAccuracy(true);
      },
      postStepFunction: () => {
        setFilledInChevrons(0);
        setAccuracyPercent(null);
      },
    },
    {
      targetId: 'ata-switch',
      title: 'Automatic Tempo Adjustment',
      feature: ApptourFeature.AUTO_TEMPO_ADJUSTMENT,
      content:
        'Auto tempo adjustment is turned on for a more seamless, personalized experience. You can turn it off at any time.',
      position: TooltipRelativePosition.LEFT,
      preStepFunction: () => {
        NotifyReactEvents.AppTourHelper({
          step: AppTourStepHelper.ExpandTempoControls,
        });
        // On mobile the expanded tempo panel may require scrolling to
        // reveal the ATA toggle.  Wait a frame for React to commit the
        // expansion, then scroll the switch into the visible area.
        setTimeout(() => {
          const el = document.getElementById('ata-switch');
          if (!el) return;
          const rect = el.getBoundingClientRect();
          const fullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (!fullyVisible) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 150);
      },
      postStepFunction: () => {
        NotifyReactEvents.AppTourHelper({
          step: AppTourStepHelper.EndTour,
        });
      },
      onClose: () => {
        NotifyReactEvents.AppTourHelper({
          step: AppTourStepHelper.EndTour,
        });
      },
    },
    {
      targetId: `free-play`,
      title: 'Game Mode',
      content: 'Game Mode is enabled by default...',
      position: isSmallScreen ? TooltipRelativePosition.TOP : TooltipRelativePosition.LEFT,
    },
    {
      targetId: `free-play`,
      title: 'Free Play',
      content: 'But in Free Play Mode, you can play indefinitely.',
      position: isSmallScreen ? TooltipRelativePosition.TOP : TooltipRelativePosition.RIGHT,
      preStepFunction: () => {
        setFreePlay(true);
      },
      postStepFunction: () => {
        setFreePlay(false);
      },
    },
  ];

  const updateTier = useCallback(
    (tier: number) => {
      dispatch(
        lessonActions.updateCurrentULP({
          currentUserLevelProgress: {
            current_tier: tier,
          },
        }),
      );
    },
    [dispatch],
  );

  const clearReps = useCallback(() => {
    setNewRepsUnlocked([]);
  }, [setNewRepsUnlocked]);

  useEffect(() => {
    if (showWrapUp && tierSummary?.played_notes && tierSummary?.played_notes > 0) {
      const newCarousel = [];
      logger.info();
      if (levelComplete && repertoireData) {
        const newReps: RepertoireData[] = [];
        repertoireData?.forEach((rep) => {
          if (rep?.level?.level_number === currentUserLevelData?.level?.level_number) {
            newReps.push(rep);
          }
        });
        setNewRepsUnlocked(newReps);
        if (newReps.length > 0 && levelCompleteFirstTime && phrasesTilNextTier === 0) {
          newCarousel.push(
            <RepertoireUnlocked newRepsUnlocked={newReps} index={newCarousel.length} />,
          );
        }
      }
      newCarousel.push(
        <TierWrapUp mediaQueries={mediaQueries} debugShowTierSummary={debugShowTierSummary} />,
      );
      if (unitComplete) {
        newCarousel.push(<UnitComplete index={newCarousel.length} />);
      }
      setCarousel(newCarousel);
    }
  }, [levelComplete, repertoireData, showWrapUp, levelCompleteFirstTime]);

  // useEffect(()=>{
  //   logger.info("hasStarted", hasStarted)
  //   logger.info("lessonPlaying", lessonPlaying)
  //   if(!hasStarted) {
  //     setHasStarted(true)
  //   } else if(hasStarted && !lessonPlaying) {
  //     setCarousel([
  //       <PauseContainer />
  //     ])
  //   } else if (hasStarted && !lessonPlaying) {
  //     setCarousel([])
  //   }
  // }, [lessonPlaying])

  const confirmBack = useCallback(() => {
    // Stop the lesson
    dispatch(lessonActions.setLessonPlaying({ lessonPlaying: false }));

    // Check if user has played at least 2 phrases
    if (completedPhrasesCount >= 2) {
      // User has played enough - show wrap up (same logic as ConfirmBack's endSession)
      dispatch(lessonActions.setLessonProcessPending(true));
      // Event queue must be clear before we initiate wrap up
      eventQueue.dispatchEvents().then(() => {
        dispatch(lessonActions.initiateWrapUp());
      });
    } else {
      // User hasn't played enough - just go back to roadmap without API request
      // Clear session data and reset state
      dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES));
      dispatch(lessonActions.setTierSummary(null));
      dispatch(lessonActions.setLessonProcessPending(false));
      dispatch(lessonActions.setShowWrapUp(false));
      dispatch(lessonActions.setWrapUpIndex(0));
      dispatch(lessonActions.resetCompletedPhrasesCount());
      dispatch(
        lessonActions.updateCurrentULP({
          currentUserLevelProgress: { play_session: { id: null } },
        }),
      );
      console.log('[MUS-61] Lesson: completedPhrasesCount reset → /roadmap');
      navigate('/roadmap');
    }
  }, [completedPhrasesCount, dispatch, navigate]);

  const replayTier = useCallback(() => {
    logger.debug('replay tier clicked');
    clearReps();
    dispatch(lessonActions.setTierSummaryRequestError(false));
    setCarousel([]);
    dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES));
    setAccuracyPercent(null);
    // await dispatch(lessonActions.resetLesson())
    dispatch(lessonActions.setTierSummary(null));
    dispatch(
      lessonActions.createLevelSession({
        level_number: data?.levelSelect,
        tier_number: currentUserLevelData?.current_tier || 1,
        error_recognition_mode: ERROR_RECOGNITION_MODE.MIDI,
      }),
    );
    dispatch(lessonActions.setTierSummary(null));
    dispatch(lessonActions.setWrapUpIndex(0));
    dispatch(lessonActions.setShowWrapUp(false));
    setShowAccuracy(false);
    setAccuracyPercent(null);
  }, [
    dispatch,
    clearReps,
    setAccuracyPercent,
    currentUserLevelData?.current_tier,
    data.levelSelect,
    setShowAccuracy,
  ]);

  const goToNextLevelOrTier = useCallback(() => {
    // Reset all wrap-up state before navigation to prevent the TierWrapUp error
    // screen from flashing during React Router's route transition.
    clearReps();
    setCarousel([]);
    dispatch(lessonActions.setTierSummary(null));
    dispatch(lessonActions.setWrapUpIndex(0));
    dispatch(lessonActions.setShowWrapUp(false));
    dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES));
    setShowAccuracy(false);
    setAccuracyPercent(null);
    if (levelComplete) {
      dispatch(
        appActions.setLevelSelect({
          levelSelect: data.levelSelect + 1,
        }),
      );
      dispatch(appActions.fetchTutorialData());
      updateTier(1);
      navigate('/tutorial');
    } else {
      dispatch(
        lessonActions.createLevelSession({
          level_number: data?.levelSelect,
          tier_number: currentUserLevelData?.current_tier
            ? currentUserLevelData?.current_tier + 1
            : 1,
          error_recognition_mode: ERROR_RECOGNITION_MODE.MIDI,
        }),
      );
    }
  }, [
    dispatch,
    clearReps,
    updateTier,
    navigate,
    levelComplete,
    currentUserLevelData?.current_tier,
    data.levelSelect,
    setShowAccuracy,
  ]);

  useEffect(() => {
    if (showWrapUp && carousel.length > 0) {
      if (wrapUpIndex >= carousel.length) {
        goToNextLevelOrTier();
      } else if (wrapUpIndex < 0) {
        replayTier();
      }
    }
  }, [wrapUpIndex]);

  useEffect(() => {
    console.log('showWrapUp changed', showWrapUp);
  }, [showWrapUp]);

  // Handle tierSummary errors - navigate back to roadmap if there's an error or no played notes
  useEffect(() => {
    if (tierSummaryRequestError || (tierSummary && !tierSummary.played_notes)) {
      // Clear state before navigating
      dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES));
      dispatch(lessonActions.setTierSummary(null));
      dispatch(lessonActions.setLessonProcessPending(false));
      dispatch(lessonActions.setShowWrapUp(false));
      dispatch(lessonActions.setWrapUpIndex(0));
      dispatch(lessonActions.resetCompletedPhrasesCount());
      console.log('[MUS-61] Lesson: tierSummaryRequestError → /roadmap');
      navigate('/roadmap');
    }
  }, [tierSummaryRequestError, tierSummary, dispatch, navigate]);

  useEffect(() => {
    setCurrentTier(currentUserLevelData?.current_tier || 1);
  }, [currentUserLevelData?.current_tier]);

  const updateCurrentTier = useCallback(
    (tier: number) => {
      if (tier !== currentTier) {
        setCurrentTier(tier);
        dispatch(
          lessonActions.createLevelSession({
            level_number: data?.levelData[levelSelect].level_number,
            tier_number: tier,
            error_recognition_mode: ERROR_RECOGNITION_MODE.MIDI,
          }),
        );
      }
    },
    [currentTier, dispatch, data?.levelData, levelSelect],
  );

  useEffect(() => {
    if (phrasesTilNextTier === 0) {
      setShowTierComplete(true);
      dispatch(lessonActions.setLessonPlaying({ lessonPlaying: !lessonPlaying }));
    }
  }, [phrasesTilNextTier]);

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };

  // Only unseen features that have a matching step in *this* tour count for
  // gating the lesson AppTour — the unseen list is global and may include
  // features that only appear in other tours (e.g. repertoire).
  const unseenLessonFeatures = unseenApptourFeatures.filter((f) =>
    LessonTutorialSteps.some((step) => step?.feature === f.key),
  );
  const hasUnseenLessonFeatures = unseenLessonFeatures.length > 0;

  useEffect(() => {
    const shouldShowFullTour = !userData?.lesson_tutorial_seenat;
    // The new-feature walkthrough waits for the MIDI "no keyboard" modal to
    // close — otherwise it pops on top of the modal. The first-login full
    // tour is intentionally not gated here.
    const shouldShowFeatureTour =
      !!userData?.lesson_tutorial_seenat && hasUnseenLessonFeatures && !showMidiModal;
    if (shouldShowFullTour || shouldShowFeatureTour) {
      if (tourTimeoutRef.current) {
        clearTimeout(tourTimeoutRef.current);
      }
      tourTimeoutRef.current = setTimeout(() => {
        if (shouldShowFeatureTour) {
          // Latch the unseen-feature list before kicking off activation.
          // Once markApptourFeaturesAsSeen fires, the saga clears
          // unseenApptourFeatures in Redux; the steps prop reads from
          // activeFeatureList so the tour can't flip into the full-tour
          // list mid-display.
          setActiveFeatureList(unseenLessonFeatures);
          setSkipIntro(true);
        }
        setTourActive(true);
        // Mark features as seen the moment the popup mounts. Waiting
        // until the user clicks GREAT means Escape / outside-click
        // dismissals silently skip the mark; the goal is to notify, and
        // by the time the popup is on screen the user has been notified.
        const walkedSlugs = unseenLessonFeatures.map((f) => f.key as ApptourFeature);
        if (walkedSlugs.length > 0) {
          dispatch(appActions.markApptourFeaturesAsSeen(walkedSlugs));
        }
      }, 1000);
    } else {
      window.addEventListener('keydown', handleKeyDown);
      return () => {
        if (tourTimeoutRef.current) {
          clearTimeout(tourTimeoutRef.current);
        }
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [hasUnseenLessonFeatures, userData?.lesson_tutorial_seenat, showMidiModal]);

  const backToRoadmap = useCallback(() => {
    console.log('[MUS-61] Lesson backToRoadmap → /roadmap');
    navigate('/roadmap');
  }, [navigate]);

  useComponentWillUnmount(() => {
    dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES));
    dispatch(lessonActions.setTierSummary(null));
    dispatch(lessonActions.setLessonProcessPending(false));
    dispatch(lessonActions.setShowWrapUp(false));
    dispatch(lessonActions.resetCompletedPhrasesCount());
  });

  const max960 = useMediaQuery('(max-width:960px), (max-height:500px)');
  const isNarrowPhone = useMediaQuery('(max-height:375px)');

  useEffect(() => {
    setIsSmallScreen(max960);
  }, [max960]);

  //   carousel: CarouselElementState[]
  const mainAppUlp = data.currentUserLevelData;
  const currentLevelNumber = data.levelData[levelSelect]?.level_number;
  const ulpMatchesCurrentLevel = mainAppUlp?.level?.level_number === currentLevelNumber;
  const saveCurrentTempoTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const saveGoalTempoTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const saveCurrentTempo = useCallback(
    (tempo: number) => {
      if (saveCurrentTempoTimerRef.current) {
        clearTimeout(saveCurrentTempoTimerRef.current);
      }
      saveCurrentTempoTimerRef.current = setTimeout(() => {
        console.log('[tempo sync] saving tempo here', tempo, currentLevelNumber, currentTier);
        dispatch(appActions.setTempo({ tempo, level: currentLevelNumber, tier: currentTier }));
        saveCurrentTempoTimerRef.current = null;
      }, 500);
    },
    [currentLevelNumber, currentTier, dispatch],
  );

  const saveGoalTempo = useCallback(
    (tempo: number) => {
      if (saveGoalTempoTimerRef.current) {
        clearTimeout(saveGoalTempoTimerRef.current);
      }
      saveGoalTempoTimerRef.current = setTimeout(() => {
        console.log('[tempo sync] saving goal tempo', tempo, currentTier);
        dispatch(appActions.setCustomGoalTempo({ tier: currentTier, tempo }));
        saveGoalTempoTimerRef.current = null;
      }, 500);
    },
    [currentTier, dispatch],
  );

  const lessonPerformanceTempo = 72;

  const onTempoResetPersistence = useCallback(
    ({ currentTempo, goalTempo }: { currentTempo: number; goalTempo: number }) => {
      if (saveCurrentTempoTimerRef.current) {
        clearTimeout(saveCurrentTempoTimerRef.current);
        saveCurrentTempoTimerRef.current = null;
      }
      if (saveGoalTempoTimerRef.current) {
        clearTimeout(saveGoalTempoTimerRef.current);
        saveGoalTempoTimerRef.current = null;
      }
      dispatch(
        appActions.setTempo({ tempo: currentTempo, level: currentLevelNumber, tier: currentTier }),
      );
      dispatch(appActions.setCustomGoalTempo({ tier: currentTier, tempo: goalTempo }));
    },
    [currentLevelNumber, currentTier, dispatch],
  );

  return (
    <TempoProvider
      performanceTempo={lessonPerformanceTempo}
      initialTempo={data.tempoValues?.[currentLevelNumber]?.[currentTier] ?? 72}
      initialGoalTempo={data.ataSettings?.goalTemposByTier?.[currentTier] ?? 150}
      saveCurrentTempo={saveCurrentTempo}
      saveGoalTempo={saveGoalTempo}
      onTempoResetPersistence={onTempoResetPersistence}
      parentContext="lesson"
    >
      <div className="tempo">
        <LessonTempoSyncer />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            backgroundColor: 'white',
          }}
        >
          <Header
            confirmBack={confirmBack}
            showTierComplete={showTierComplete}
            currentTier={currentTier}
            updateCurrentTier={updateCurrentTier}
            showAccuracy={showAccuracy}
            accuracyPercent={accuracyPercent}
            levelSelect={levelSelect}
            phrasesTilNextTier={phrasesTilNextTier}
            allowChevrons={allowChevrons}
            freePlay={freePlay}
            setFreePlay={setFreePlay}
            setTourActive={setTourActive}
            numChevronsFilledIn={filledInChevrons}
            setShowTutorialVideo={setShowTutorialVideo}
            mobile={isSmallScreen}
            compactTempo={isNarrowPhone}
          />
          <Box
            className="main-app-container-styles"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              //overflow: 'hidden',
            }}
          >
            <MainAppPhaser
              showTierComplete={showTierComplete}
              currentTier={currentTier}
              setCurrentTier={setCurrentTier}
              updateCurrentTier={updateCurrentTier}
              showKeyboard={false}
              setAccuracy={setAccuracyPercent}
              setShowAccuracy={setShowAccuracy}
              setAllowChevrons={setAllowChevrons}
              cursorIsVisible={cursorIsVisible}
              setCursorIsVisible={setCursorIsVisible}
              freePlay={freePlay}
              mobile={isSmallScreen}
              playButtonOverlap={playButtonOverlap}
              settingsShown={showSettings}
              onCloseSettings={() => setShowSettings(false)}
              setShowDebugTierSummary={setDebugShowTierSummary}
              showDebugTierSummary={debugShowTierSummary}
              setShowDebugRepertoireUnlocked={setDebugShowRepertoireUnlocked}
              showDebugRepertoireUnlocked={debugShowRepertoireUnlocked}
              sightReadingTransposeSemitones={sightReadingTransposeSemitones}
              onSightReadingTransposeChange={setSightReadingTransposeSemitones}
              sightReadingModeConversion={sightReadingModeConversion}
              onSightReadingModeConversionChange={setSightReadingModeConversion}
              onSightReadingKeyChange={setSightReadingCurrentKeyLabel}
              // midiProps={midiProps}
            />
          </Box>
          <Box
            sx={{
              position: 'absolute',
              height: '100%',
              width: '100%',
              backgroundColor: '#414753',
              opacity: '80%',
              visibility: carousel.length && showWrapUp ? 'visible' : 'hidden',
              zIndex: 1999,
            }}
          />
          {/* less than 0 or greater than length is what triggers next or previous action*/}
          {wrapUpIndex >= 0 && wrapUpIndex < carousel.length && showWrapUp && (
            <Modal>
              {/* Don't show back button on unit complete. (handled in component) */}
              {phrasesTilNextTier === 0 &&
                !(unitComplete && wrapUpIndex === carousel.length - 1) && (
                  <BackToRoadmapButton onClick={backToRoadmap} />
                )}
              {!lessonProcessPending && (
                <>
                  {carousel[wrapUpIndex]}
                  {/* Check if tier is complete before showing nav (as opposed to user ending session). Also, don't show nav on unit complete. */}
                  {phrasesTilNextTier == 0 &&
                    !(unitComplete && wrapUpIndex === carousel.length - 1) && (
                      <Navigation
                        {...props}
                        sx={{
                          marginTop: { xs: '16px', md: 'auto' },
                          bottom: { xs: '10px', lg: '40px' },
                        }}
                        nextButtonSx={{
                          width: { xs: '120px', sm: '160px', md: '200px' },
                        }}
                        backText={wrapUpIndex > 0 ? 'Back' : 'Replay Tier'}
                        nextText={wrapUpIndex >= carousel.length - 1 ? 'Keep playing' : 'Next'}
                        onBack={() => {
                          if (wrapUpIndex <= 0) {
                            replayTier();
                          } else {
                            dispatch(lessonActions.setWrapUpIndex(wrapUpIndex - 1));
                          }
                        }}
                        onNext={() => {
                          if (wrapUpIndex >= carousel.length - 1) {
                            goToNextLevelOrTier();
                          } else {
                            dispatch(lessonActions.setWrapUpIndex(wrapUpIndex + 1));
                          }
                        }}
                        carousel={carousel.map((_, _indx) =>
                          _indx === wrapUpIndex ? 'active' : 'inactive',
                        )}
                      />
                    )}
                </>
              )}
            </Modal>
          )}

          {/* No idea why this is coming up on the unit complete screen, but hope this prevents it. */}
          {wrapUpIndex >= 0 &&
            wrapUpIndex < carousel.length &&
            !showWrapUp &&
            phrasesTilNextTier !== 0 && (
              <Modal
                sx={{
                  height: 300,
                  width: 550,
                  minWidth: 550,
                  minHeight: 300,
                }}
              >
                {carousel[wrapUpIndex]}
              </Modal>
            )}

          <FooterContainer
            toggleSettings={() => setShowSettings((prev) => !prev)}
            playButtonActive={!tourActive}
            cursorIsVisible={cursorIsVisible}
            setCursorIsVisible={setCursorIsVisible}
            debugShowTierSummary={debugShowTierSummary}
            setDebugShowTierSummary={setDebugShowTierSummary}
            setFreePlay={setFreePlay}
            freePlay={freePlay}
            mobile={isSmallScreen}
            onPlayButtonOverlapChange={setPlayButtonOverlap}
            showTransposeControls={true}
            transposeSemitones={sightReadingTransposeSemitones}
            onTransposeChange={setSightReadingTransposeSemitones}
            modeConversion={sightReadingModeConversion}
            onModeConversionChange={setSightReadingModeConversion}
            currentKeyLabel={sightReadingCurrentKeyLabel}
          />
        </Box>
        {process.env.REACT_APP_NODE_ENV === 'local' && debugShowTierSummary && (
          <Modal
            sx={{
              height: 'auto',
              width: 'min(92vw, 900px)',
              minHeight: 400,
            }}
          >
            <TierWrapUp mediaQueries={mediaQueries} debugShowTierSummary={debugShowTierSummary} />
          </Modal>
        )}
        {process.env.REACT_APP_NODE_ENV !== 'prd' && debugShowRepertoireUnlocked && (
          <Modal sx={{ height: isSmallScreen ? '80vh' : '60vh', minHeight: 'unset' }}>
            <BackToRoadmapButton onClick={() => setDebugShowRepertoireUnlocked(false)} />
            <RepertoireUnlocked newRepsUnlocked={DEBUG_REPERTOIRE_UNLOCKED} index={0} />
          </Modal>
        )}
        <LessonAppTour
          skipIntro={skipIntro}
          videoLink="https://assets.museflow.ai/videos/game-tutorials/sight-reading-trainer-tutorial.mov"
          steps={
            activeFeatureList.length > 0
              ? filterByUnseenFeatures(
                  LessonTutorialSteps.filter((step) => step !== null) as AppTourStep[],
                  activeFeatureList,
                )
              : (LessonTutorialSteps.filter((step) => step !== null) as AppTourStep[])
          }
          isOpen={tourActive}
          onClose={() => {
            setSkipIntro(false);
            setTourActive(false);
            setActiveFeatureList([]);
            // Features are marked seen on tour activation, not here —
            // dismissing via Escape / outside-click should not skip
            // the mark.
            //
            // Only stamp lesson_tutorial_seenat the first time. Re-dispatching
            // a fresh Date when it's already set changes the userData
            // reference and re-fires the activation effect, which can
            // re-open the (now full) tour while the unseen-list refetch is
            // still in flight.
            //
            // updateUserData (not setUserData) so the stamp is PATCHed to
            // /user-data and survives the next userData re-fetch — matching
            // the skip path below. SET_USER_DATA has no saga, so a
            // local-only stamp is wiped by authenticatedStartup and the
            // full tour re-appears every session (MUS-391).
            if (!userData?.lesson_tutorial_seenat) {
              dispatch(
                appActions.updateUserData({
                  lesson_tutorial_seenat: new Date(),
                }),
              );
            }
            setTourStepIndex(0);
            dispatch(lessonActions.updatePhrasesTilNextTier(4));
            setAccuracyPercent(null);
            setShowAccuracy(false);
          }}
          onStepChange={(indx: number) => setTourStepIndex(indx)}
          onSkipTour={() => {
            setTourActive(false);
            setSkipIntro(false);
            setActiveFeatureList([]);
            if (!userData?.lesson_tutorial_seenat) {
              dispatch(
                appActions.updateUserData({
                  lesson_tutorial_seenat: new Date(),
                }),
              );
            }
          }}
        />
        {showTutorialVideo && (
          <MuiModal
            open={showTutorialVideo}
            sx={{
              // height: 'auto',
              width: 'min(1000px, 94vw)',
              minWidth: 320,
              minHeight: 200,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              background: 'black',
              height: '600px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              padding: '20px',
              maxHeight: '80vh',
              // padding: '20px'
            }}
          >
            <>
              <Box sx={{ position: 'absolute', top: 5, right: 12 }}>
                <IconButton
                  aria-label="Close video"
                  onClick={() => setShowTutorialVideo(false)}
                  sx={{ color: '#CED0D4' }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Box sx={{ width: '100%' }}>
                  <video
                    style={{ width: '100%', maxHeight: '70vh', borderRadius: 8 }}
                    controls
                    autoPlay
                    muted={false}
                    playsInline
                  >
                    <source src="https://assets.museflow.ai/videos/game-tutorials/sight-reading-trainer-tutorial.mov" />
                    Your browser does not support the video tag.
                  </video>
                </Box>
              </Box>
            </>
          </MuiModal>
        )}
      </div>
    </TempoProvider>
  );
};

const accuracyColors = [
  '#00C2FF', //neutral
  '#40E16D', // green
  '#FFBF00', // yellow
  '#ff7d6f',
  // 'rgba(200, 128, 114, 1.0)',// '#EB3459', // red
];

interface HeaderProps {
  levelSelect: number;
  accuracyPercent: number | null;
  showAccuracy: boolean;
  phrasesTilNextTier: number;
  allowChevrons: boolean;
  updateCurrentTier: (tier: number) => void;
  currentTier: number;
  showTierComplete: boolean;
  confirmBack: () => void;
  freePlay: boolean;
  setFreePlay: Dispatch<SetStateAction<boolean>>;
  setTourActive: Dispatch<SetStateAction<boolean>>;
  numChevronsFilledIn: number;
  mobile: boolean;
  compactTempo: boolean;
  setShowTutorialVideo: Dispatch<SetStateAction<boolean>>;
}

const Header = (props: HeaderProps) => {
  const {
    accuracyPercent,
    showAccuracy,
    allowChevrons,
    updateCurrentTier,
    currentTier,
    showTierComplete,
    confirmBack,
    freePlay,
    setFreePlay,
    setTourActive,
    numChevronsFilledIn,
    mobile,
    compactTempo,
    setShowTutorialVideo,
  } = props;

  const { tempo, setFreePlayMode } = useTempoContext();

  useEffect(() => {
    setFreePlayMode(freePlay);
  }, [freePlay]);
  // const accuracyPercent = 0 // test value; comment out accuracyPercent from props above
  // const phrasesTilNextTier = 3 // test value; comment out phrasesTilNextTier from props above

  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const lessonData = useSelector((state: LessonReducer) => state.lessonReducer);
  const {
    currentUserLevelData,
    phrasesTilNextTier,
    currentLevelTiers,
    lessonPlaying: _lessonPlaying,
  } = useSelector((state: LessonReducer) => state.lessonReducer);
  const levelSelect = data.levelSelect;
  const levelData = data.levelData;
  const levelName = levelData[levelSelect].name;
  const levelNumber = levelData[levelSelect].level_number;
  const navigate = useNavigate();

  const tempoContainerRef = useRef<HTMLImageElement | null>(null);
  const tempoInputRef = useRef<HTMLInputElement | null>(null);
  const tempoToggleRef = useRef<HTMLDivElement | null>(null);

  const chevronPulseStyles = {
    height: '100%',
    animation:
      allowChevrons && accuracyPercent && accuracyPercent >= activationAccuracyValue
        ? `pulse ${60 / Math.min(tempo, minTempoForChevronFlash)}s infinite linear`
        : '',
  };
  const _chevronContainerStyles = {
    position: 'absolute' as const,
    height: '100%',
  };

  const positionData = [
    { til: 4, filledSrc: ChevronFilled, src: Chevron1 },
    { til: 3, filledSrc: ChevronFilled, src: Chevron1 },
    { til: 2, filledSrc: ChevronFilled, src: Chevron1 },
    { til: 1, filledSrc: ChevronLastFilled, src: ChevronSingle },
  ];

  let accuracyColor;
  if (accuracyPercent == 0) {
    accuracyColor = accuracyColors[0];
  } else if (accuracyPercent && accuracyPercent >= 95) {
    accuracyColor = accuracyColors[1];
  } else if (accuracyPercent && accuracyPercent >= 75) {
    accuracyColor = accuracyColors[2];
  } else {
    accuracyColor = accuracyColors[3];
  }

  const [infoAnchorEl, setInfoAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(infoAnchorEl);
  const handleInfoClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setInfoAnchorEl(event.currentTarget);
  };
  const handleInfoClose = () => {
    setInfoAnchorEl(null);
  };

  const lesson = useSelector((state: LessonReducer) => state.lessonReducer);

  const freePlaySelectedStyles = {
    // boxShadow: !freePlay ? '0 0 8px rgba(45, 109, 163, 0.8)': 'none'
    transform: 'scale(1.05, 1)',
    transition: 'transform 0.2s',
    overflow: 'hidden',
    '& p': {
      fontWeight: 'bold',
    },
    height: '30px',
  };

  const _hiddenStyles =
    lesson.lessonPlaying && mobile
      ? {
          transform: 'translateY(-80px)',
        }
      : {
          transform: 'none',
        };

  const _hiddenStylesChevrons =
    lesson.lessonPlaying && mobile
      ? {
          transform: 'translateY(80px)',
        }
      : {
          transform: 'none',
        };

  const accuracyEl = (
    <Box
      id="accuracy"
      sx={{
        //background: 'linear-gradient(270deg, #1D2F44 28.99%, #071423 90.95%);',
        //background: '#1d2f45',
        background: mobile ? (freePlay ? 'black !important' : '#1d2f45') : '#1d2f45',
        width: '300px',
        // On mobile the tempo+accuracy flex wrapper owns the slide transform.
        transform: 'none',
        transition: 'transform 1s ease-in-out',
        marginLeft: '-1px',
        // On mobile, neutralize the absolute positioning from the #accuracy
        // media query so it can sit as a flex child next to the tempo control.
        ...(mobile ? { position: 'static !important', right: 'auto !important' } : {}),
      }}
    >
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          position: 'relative',
          marginLeft: mobile ? '0' : '20px',
          width: '100%',
        }}
      >
        {/*<Box
          className="first-chevron-styles"
          sx={{
            left: '-21px',
          }}
          // sx={{
          //   ...(freePlay ? {
          //     display: 'none'
          //   } : {})
          // }}
        />*/}
        <Box
          id="chevron-array-parent"
          sx={{
            ...(freePlay
              ? {
                  display: 'none !important',
                }
              : {}),
          }}
        >
          <div id="chevron-bg-fill"></div>
          <div style={{ width: '100%', position: 'relative' }}>
            {positionData.map((v, _idx) => {
              const curChevronDiff = v.til - (4 - numChevronsFilledIn);
              const style = curChevronDiff === 0 ? chevronPulseStyles : { height: '100%' };
              //const style = chevronPulseStyles;
              const filledClass = curChevronDiff > 0 ? 'inner filled' : 'inner';
              return (
                <Box key={uuid()} className="chevron">
                  {<div className={filledClass} style={style}></div>}
                </Box>
              );
            })}
          </div>
          <div id="gradient"></div>
        </Box>
        <Box className="accuracy-container-styles2">
          {/*<Box className="accuracy-title-text-styles">Accuracy</Box>*/}
          {showAccuracy && (
            <Box className="accuracy-text-styles" sx={{ color: accuracyColor }}>
              {accuracyPercent ? `${accuracyPercent?.toFixed(1)}%` : '--'}
            </Box>
          )}
          {!showAccuracy && <Box className="accuracy-text-styles">--</Box>}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box className="lesson-container-styles">
      {showTierComplete && (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            visibility: lessonData.phrasesTilNextTier === 0 ? 'unset' : 'hidden',
            backgroundColor: '#414753',
            opacity: '70%',
            position: 'absolute',
            zIndex: '1500',
          }}
        />
      )}
      <Box
        sx={{
          // background: 'linear-gradient(90deg, black, #1D2F44)',
          ..._hiddenStyles,
          background: 'linear-gradient(270deg, #1D2F44 28.99%, #071423 90.95%)',
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: mobile ? 'flex-start' : 'center',
          padding: mobile ? '10px 10px' : '0px',
          transition: 'transform 1s ease-in-out',
          justifyContent: 'space-between',
          //zIndex: 3000,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            height: '100%',
            justifyContent: 'space-between',
            marginLeft: mobile ? '0px' : '80px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: mobile ? 'unset' : '465px',
            zIndex: 1100,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              flex: 1,
              width: '100%',
            }}
          >
            <Box
              sx={backcontainerStyles}
              onClick={() => {
                confirmBack();
              }}
            >
              <img style={{ height: '100%' }} src={LeftArrowIcon} />
            </Box>
            <Box
              sx={{
                flex: 1,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: mobile ? '8px' : '20px',
                rowGap: '10px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  width: '100%',
                  justifyContent: 'center',
                  columnGap: mobile ? '8px' : '20px',
                }}
              >
                <Box className="header-text-styles">
                  <b>Level {levelNumber}: </b>
                  {levelName}
                </Box>
                <Box
                  sx={{
                    ...backcontainerStyles,
                    //marginLeft: '10px',
                    margin: 0,
                    border: '1px solid rgba(202, 124, 98, .8)',
                    borderRadius: '7px',
                    padding: '3px 8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    '&:hover': { cursor: 'pointer' },
                  }}
                  onClick={handleInfoClick}
                >
                  <img style={{ height: '18px' }} src={InfoIcon} />
                  <svg
                    xmlns="https://www.w3.org/2000/svg"
                    width="14"
                    height="9"
                    viewBox="0 0 14 9"
                    fill="none"
                  >
                    <path
                      d="M6.53151 4.97725L7.32365 5.74557L8.14993 4.96948L12.7227 0.44849L13.8975 1.62326L7.34521 8.17551L0.792969 1.62326L1.96774 0.44849L6.53151 4.97725Z"
                      fill="#CA7C62"
                    />
                  </svg>
                </Box>

                <Menu
                  id="tutorial-info-menu"
                  anchorEl={infoAnchorEl}
                  open={open}
                  onClose={handleInfoClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    sx: {
                      backgroundColor: 'black',
                    },
                  }}
                  sx={{
                    zIndex: 3000,
                    '.MuiList-root': {
                      zIndex: 10000,
                    },
                    '.MuiListItemText-root': {
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                    'bgcolor.MuiList-root-MuiMenu-list': {
                      zIndex: 2000,
                      backgroundColor: 'black',
                      color: '#fff',
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleInfoClose();
                      navigate('/tutorial');
                    }}
                  >
                    <ListItemIcon sx={{ svg: { fill: MUSEFLOW_ORANGE } }}>
                      <AutorenewIcon fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Level Tutorial</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleInfoClose();
                      setTourActive(true);
                    }}
                  >
                    <ListItemIcon sx={{ svg: { fill: MUSEFLOW_ORANGE } }}>
                      <AutorenewIcon fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Game Tutorial</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleInfoClose();
                      setShowTutorialVideo(true);
                    }}
                  >
                    <ListItemIcon sx={{ svg: { fill: MUSEFLOW_ORANGE } }}>
                      <PlayCircleOutlineIcon fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Watch Tutorial Video</ListItemText>
                  </MenuItem>
                </Menu>
              </Box>
              <Box
                sx={{
                  position: 'relative',
                  //top: '44px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  width:
                    currentLevelTiers > 1
                      ? mobile
                        ? '300px'
                        : '370px'
                      : mobile
                        ? '180px'
                        : '230px',
                  //marginRight: '20px',
                }}
              >
                {range(1, currentLevelTiers + 1).map((tier) => {
                  const hasReachedTier =
                    currentUserLevelData?.highest_tier_complete &&
                    currentUserLevelData?.highest_tier_complete >= tier;
                  const isUnlocked =
                    process.env.REACT_APP_NODE_ENV === 'local' ||
                    process.env.REACT_APP_NODE_ENV === 'dev' ||
                    tier == 1 ||
                    (currentUserLevelData?.highest_tier_complete &&
                      tier == currentUserLevelData?.highest_tier_complete + 1);
                  console.debug('[Lesson] isUnlocked', isUnlocked, process.env.REACT_APP_NODE_ENV);
                  let _chosenStyles: Record<string, unknown> = {};
                  let bgColor = colors.background.incomplete.backgroundColor;
                  if (hasReachedTier) {
                    _chosenStyles = completeContainerStyles;
                    bgColor = colors.background.complete.backgroundColor;
                  } else if (isUnlocked) {
                    _chosenStyles = {
                      ...inProgressContainerStyles,
                      border: '3px solid #28856F',
                    };
                    bgColor = '#ADB1B7';
                  }
                  return (
                    <Box
                      key={tier}
                      sx={{
                        position: 'relative',
                        height: mobile ? '18px' : '22px',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        flexGrow: 1,
                        marginRight: '5px',
                        marginLeft: '5px',
                      }}
                    >
                      <Box
                        // uuid() creates a new key every render, so React unmounts and remounts the element on every state change. With your app constantly updating (Redux, timers, etc.), it’s very easy for a re-render to happen between pointerdown and click, so the event is dispatched to a node that no longer exists and your handler never runs.
                        //key={tier} // This was a uuid() before.. huge mistake made the onclick fail, very bizzare
                        sx={{
                          borderRadius: '99px',
                          backgroundColor: bgColor,
                          //display: 'flex',
                          //alignItems: 'center',
                          //justifyContent: 'center',
                          //flexGrow: 1,
                          //height: mobile ? '10px' : '14px',
                          height: 'calc(100% - 8px)',
                          width: 'calc(100% - 4px)',
                          //position: 'relative',
                          //marginRight: '5px',
                          //marginLeft: '5px',
                          '&:hover': {
                            cursor: hasReachedTier || isUnlocked ? 'pointer' : '',
                            transition:
                              tier == currentTier || hasReachedTier || isUnlocked ? '' : '0.3s',
                            boxShadow:
                              tier == currentTier ||
                              (tier != currentTier && !hasReachedTier && !isUnlocked)
                                ? ''
                                : '0px 0px 5px 5px rgb(70, 159, 106,.5)',
                          },
                        }}
                        onClick={() => {
                          // Weird bug that makes next tier chevrons full if clicked during tier complete dialogue
                          // so just make them not doing anything if phrases til next tier is zero
                          if ((hasReachedTier || isUnlocked) && !(phrasesTilNextTier === 0)) {
                            updateCurrentTier(tier);
                          }
                        }}
                      />
                      {tier == currentTier && (
                        <Box
                          sx={{
                            borderRadius: '10px',
                            backgroundColor: 'rgba(70, 159, 106, 0.2)',
                            border: '2px solid rgba(70, 159, 106, .8)',
                            position: 'absolute',
                            width: '100%',
                            height: 'calc(100% - 4px)',
                            zIndex: 10,
                          }}
                        />
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
        {/* Desktop: tempo lives in the header bar. On mobile it is rendered
            next to the accuracy pill below so it stays put during playback. */}
        {!mobile && (
          <TempoControls
            playing={false}
            tempoToggleRef={tempoToggleRef}
            tempoContainerRef={tempoContainerRef}
            tempoInputRef={tempoInputRef}
          />
        )}
      </Box>
      {!mobile && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            display: 'flex',
            alignItems: 'end',
            alignContent: 'center',
            justifyContent: 'center',
            //zIndex: 3000,
          }}
        >
          <Box
            id="free-play"
            sx={{
              height: '30px',
              width: '240px',
              background: '#414753',
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'center',
              borderRadius: '20px 20px 0 0' /* top-left, top-right, bottom-right, bottom-left */,
              '& p': {
                color: '#fff',
                margin: '5px',
                padding: 0,
              },
              zIndex: 1000,
              // margin: '10px'
            }}
          >
            <Box
              sx={{
                // height: '30px',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                width: '120px',
                background: !freePlay ? '#6F87F1' : '#414753',
                borderRadius: '20px 0 0 0' /* top-left, top-right, bottom-right, bottom-left */,
                borderRightStyle: 'solid',
                borderColor: '#414753',
                '&:hover': {
                  cursor: 'pointer',
                },
                ...(!freePlay ? freePlaySelectedStyles : {}),
              }}
              onClick={() => setFreePlay(false)}
            >
              <p>Game</p>
            </Box>
            <Box
              sx={{
                // height: '30px',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                width: '120px',
                background: freePlay ? '#6F87F1' : '#414753',
                borderRadius: '0 20px 0 0' /* top-left, top-right, bottom-right, bottom-left */,
                borderLeftStyle: 'solid',
                borderColor: '#414753',
                // boxShadow: freePlay ? '0 0 8px rgba(45, 109, 163, 0.8)': 'none'
                transform: freePlay ? 'scale(1.05)' : 'none' /* Slightly bigger */,
                transition: freePlay ? 'transform 0.2s' : 'none',
                '&:hover': {
                  cursor: 'pointer',
                },
                ...(freePlay ? freePlaySelectedStyles : {}),
              }}
              onClick={() => setFreePlay(true)}
            >
              <p>Free Play</p>
            </Box>
          </Box>
        </Box>
      )}

      {/* Mobile: group the tempo controls with the accuracy pill in one
          flex row (tempo to the left). The wrapper is positioned like the
          accuracy pill used to be and carries the playback slide transform,
          so both stay put together when the header bar slides away. */}
      {mobile ? (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: '16px',
            height: 'var(--header-height)',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '12px',
            zIndex: 3100,
          }}
        >
          <TempoControls
            playing={lesson.lessonPlaying}
            compact={compactTempo}
            tempoToggleRef={tempoToggleRef}
            tempoContainerRef={tempoContainerRef}
            tempoInputRef={tempoInputRef}
          />
          {accuracyEl}
        </Box>
      ) : (
        accuracyEl
      )}
    </Box>
  );
};

const _lineStyles = {
  height: '5px',
  flexGrow: 1,
  borderRadius: '99px',
};

const _circleStyles = {
  width: '26px',
  height: '26px',
  borderRadius: '50%',
};

const backcontainerStyles = {
  marginRight: '18px',
  height: '25px',
  '&:hover': {
    background: 'rgba(222,144,118,.5)',
    cursor: 'pointer',
    transition: '0.3s',
    borderRadius: '50%',
    boxShadow: '0px 0px 5px 5px rgb(222,144,118,.5)',
  },
};

export default LessonPage;
